import classNames from 'classnames';
import * as React from 'react';
import ReactSlick, { Settings } from 'react-slick';

import { BlockSectionClassResolver } from '../../BlockSection/BlockSectionClassResolver';
import { DiscountVariant } from '../DiscountVariant.csharp';
import MainBanner from '../MainBanner/MainBanner';
import { MainBannerViewModel } from '../MainBanner/MainBannerViewModel.csharp';
import { MainBannerGalleryProps } from './MainBannerGalleryProps.csharp';

export class MainBannerGallery extends React.Component<MainBannerGalleryProps> {
    private sliderRef = React.createRef<ReactSlick>();
    private readonly sliderSettings = {
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        pauseOnHover: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        useTransform: false,
        appendDots: (dots) => <ul>{dots}</ul>
    } as Settings;

    constructor(props: MainBannerGalleryProps) {
        super(props);

        this.nextSlide = this.nextSlide.bind(this);
        this.prevSlide = this.prevSlide.bind(this);
    }

    nextSlide() {
        this.sliderRef.current && this.sliderRef.current.slickNext();
    }

    prevSlide() {
        this.sliderRef.current && this.sliderRef.current.slickPrev();
    }

    render() {
        const [items, profile] = [this.props.model.items, this.props.profile];
        const { blockSectionMargin } = this.props.model;
        const firstItem = items?.length > 0 ? items[0] : null;

        return (
            <>
                <section className={classNames('MainBannerGallery', 'MainBannerGallery--Desktop', BlockSectionClassResolver.Resolve(blockSectionMargin))}>
                    <ReactSlick ref={this.sliderRef} {...this.sliderSettings}>
                        {items.length > 0 &&
                            items.map((item: MainBannerViewModel, index: number) => (
                                <MainBanner model={item} profile={profile} key={index} discountVariant={DiscountVariant.Large} isLazyLoaded={index > 0} />
                            ))}
                    </ReactSlick>
                </section>
                {firstItem && (
                    <section className={classNames('MainBannerGallery', 'MainBannerGallery--Mobile', BlockSectionClassResolver.Resolve(blockSectionMargin))}>
                        <MainBanner model={firstItem} profile={profile} discountVariant={DiscountVariant.Large} isLazyLoaded={false} />
                    </section>
                )}
            </>
        );
    }
}
